import { Component } from '@angular/core';
import { Globals } from '../../services/globals';
import { NoticeController } from '../../services/notice.controller';
import { NoticeService } from '../../services/notice.service';

@Component({
  templateUrl: './notice.html',
  styleUrls: ['./notice.scss'],
})

export class NoticePage {

  /**
   * 센터 번호들
   */
  private $centers: string;

  /**
   * 보여줄 공지사항 수
   */
  private $cnt: number = 15;

  /**
   * 시작 인덱스
   */
  private $sIndex: number = 0;

  /**
   * 공지사항 리스트
   */
  noticeList: any[];

  /**
   * 공자시항이 더 존재 하는지 여부
   */
  hasMoreNotice: boolean = true;

  /**
   * @constructor
   */
  constructor(
    private $noticeService: NoticeService,
    g: Globals,
    private $noticeController: NoticeController) {
    this.$centers = g.centerNums.join(',');
    this.noticeList = [];

    // 범위가 있는 공지사항 가져오기
    this.getNoticeList();
  }

  /**
   * 공지사항목록에서 한달이 지나지 않고 사용자가 읽지 않은 공지사항을 구별해서 목록에 추가
   * @param notice 공지사항
   */
  private noticeMapper = (n) => {
    this.noticeList.push({
      num : n.crm_num,
      title : n.crm_subject,
      isNew : this.$noticeController.isNew(n),
      status : false,
      content: n.crm_content,
      date: new Date(n.crm_date),
    });
  }

  /**
   * 범위가 있는 공지사항 가져오기
   */
  getNoticeList() {
    // TODO: 로딩 구현
    this.$noticeService.limitNotice(this.$centers, this.$sIndex, this.$cnt).subscribe(
        (data) => {
          // 더보기 출력 여부 설정
          this.hasMoreNotice = data.length !== 0;
          data.forEach(this.noticeMapper);
          this.$sIndex = this.$sIndex + this.$cnt;
          // 공지사항 서비스 업데이트
          this.$noticeController.newNoticeUpdate();
        },
        (err) => {
          console.log('Notice list error', err);
        });
  }

  /**
   * 공지사항 클릭
   * @param {any} n 공지사항
   */
  openNotice(n) {
    // 내용 보여주기
    n.status = !n.status;
    if (!n.isNew) return;
    // 읽지 않은 공지사항이라면 읽음 표시
    n.isNew = false;
    this.$noticeService.addNotice(n.num).
        // 공지사항 서비스 업데이트
        subscribe(
          () => {
            this.$noticeController.newNoticeUpdate();
          },
          (err) => {
            console.log('Add notice error', err);
          });
  }
}
